<template>
  <div>
    <!-- Navigation -->
    <navigation
      @prev="$emit('prev')"
      @next="$emit('next')"
      :activeStepIndex="activeStepIndex"
      :$v="$v"
      :processing-api="processingApi"
    />

    <!-- Form -->
    <div class="form-group">
      <label :class="survey.id == 552 ? 'color-avai' : 'black'" class="title-bold" for="nome">{{$t('email_field')}}</label>
      <div class="error mt-n2" v-if="$v.localEmail.$error">
        <span class="error " v-if="!$v.localEmail.required">{{ $t('email') + $t('is_required') }}</span>
        <span class="error " v-else-if="!$v.localEmail.validEmail">{{ $t('email') + $t('invalid')}}</span>
      </div>
      <!-- Email Input -->
      <input
        type="text"
        class="form-control"
        id="email"
        :placeholder="$t('type_email_here')"
        v-model="localEmail"
        @keydown.enter="focusOn('emailConfirmation')"
        @blur="$v.localEmail.$touch()"
      />

      <label :class="survey.id == 552 ? 'color-avai' : 'black'" class="title-bold" for="nome">{{$t('confirm_email')}}</label>
      <div class="error mt-n2" v-if="$v.localEmailConfirm.$error">
        <span class="error " v-if="!$v.localEmailConfirm.sameAsLocalEmail">{{$t('enter_same_email')}}</span>
      </div>
      <!-- Confirm Email Input -->
      <input
        type="text"
        class="form-control"
        id="emailConfirmation"
        placeholder="Confirme aqui"
        v-model="localEmailConfirm"
        @keyup.enter="goToNextStep"
        @blur="$v.localEmailConfirm.$touch()"
        onpaste="return false;"
      />
    </div>

    <!-- Button -->
    <section class="row">
      <div class="col-12 mt-5 mx-auto col-md-6">
        <button
          :style="
            style.surveyBtnColor
              ? { backgroundColor: style.surveyBtnColor }
              : { backgroundColor: style.homeBtnColor }
          "
          type="submit"
          class="w-100 btn btn-primary btn-block my-3"
          @click="goToNextStep"
          :disabled="$v.$invalid"
        >
          {{ $t('advance') }}
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
            v-if="processingApi"
          ></span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import {sameAs, required} from 'vuelidate/lib/validators'
import Navigation from "@/components/registration/components/Navigation";

const validEmail = (email) => {
  if (email.length < 5) return false
  if (email.includes("@") && email.includes(".")) return true
  else return false
}

export default {
  name: "Email",
  components: {Navigation},
  props: {
    profile: {
      type: Object,
      required: true
    },
    processingApi: {
      type: Boolean,
      required: true
    },
    activeStepIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      localEmail: '',
      localEmailConfirm: ''
    }
  },
  computed: {
    style() {
      return this.$store.state.template.style;
    },
     survey() {
      return this.$store.state.template.survey;
    },
  },
  validations: {
    localEmail: {
      required,
      validEmail
    },
    localEmailConfirm: {
      sameAsLocalEmail: sameAs('localEmail')
    }
  },
  watch: {
    localEmail () {
      this.profile.Numbers[1].Number = this.localEmail
    }
  },
  mounted() {
    this.localEmail = this.profile.Numbers[1].Number
    if (this.activeStepIndex !== 0) this.focusOn('email')
  },
  methods: {
    focusOn(el) {
      document.getElementById(el).focus();
    },
    goToNextStep() {
      if (!this.$v.$invalid) this.$emit('next')
    }
  }
}
</script>
<style scoped>
.color-avai{
  color: #123654 !important;
}
</style>